export default __webpack_public_path__ + "media/images/icons/calendar-grey-a057342e9a19b879dc8403b3d91472e7.svg";